<label class="ui-g-5 field-label text-right-align fix-label-position" [ngClass]="{ required: required }">
  {{ label }}
</label>
<div [formGroup]="form" class="container">
  <input type="text" pInputText formControlName="name" [attr.disabled]="true" />
  <p-fileUpload
    *ngIf="!form.controls.file.value && !disabled"
    mode="basic"
    maxFileSize="1000000"
    [showUploadButton]="false"
    (onSelect)="upload($event)"
    chooseIcon="pi pi-upload"
    [disabled]="disabled"></p-fileUpload>
  <p-button *ngIf="form.controls.file?.value" icon="pi pi-eye" (onClick)="openFile()" class="download-btn" [disabled]="disabled"></p-button>
  <p-button
    *ngIf="form.controls.id.value && !form.controls.file?.value"
    icon="pi pi-download"
    (onClick)="download()"
    class="download-btn"></p-button>
  <p-button
    *ngIf="(form.controls.file?.value || form.controls.id.value) && !disabled"
    icon="pi pi-times"
    (onClick)="clear()"
    class="clear-btn"
    [disabled]="disabled"></p-button>
</div>
